import React from 'react';
import './Packages.css';

const Packages = () => {
    return (
        <div className="packages-container">
            <div className="partnership-page-title">
                <h2>Partnership Packages</h2>
                <p>Empowering the next generation of Electronics Engineers together.</p>
            </div>

            {/* General Benefits */}
            <section className="general-benefits-overview">
                <div className="benefits-card">
                    <h3>General Benefits</h3>
                    <ul>
                        <li>Discounts for Brodkast ng Talino participants</li>
                        <li>Billing acknowledgment on all publication materials</li>
                        <li>Inclusion of logo in Brodkast ng Talino publication materials</li>
                        <li>Follow partner organization’s Facebook page</li>
                        <li>Live acknowledgement before and after the event</li>
                    </ul>
                </div>
            </section>

            {/* Tier Cards */}
            <div className="tier-grid">
                <div className="tier-card tier-gold">
                    <div className="card-header">
                        <h3>GOLD</h3>
                        <span className="price-tag">Php 540 - 680</span>
                    </div>
                    <p className="tier-desc">Maximum Exposure & Premium Billing</p>
                    <ul className="tier-mini-list">
                        <li>8 Required Participants</li>
                        <li>Large Logo Placement</li>
                        <li>"In Partnership With"</li>
                    </ul>
                </div>

                <div className="tier-card tier-silver">
                    <div className="card-header">
                        <h3>SILVER</h3>
                        <span className="price-tag">Php 540 - 680</span>
                    </div>
                    <p className="tier-desc">High Visibility & Strategic Growth</p>
                    <ul className="tier-mini-list">
                        <li>5 Required Participants</li>
                        <li>Medium Logo Placement</li>
                        <li>"Brought To You By"</li>
                    </ul>
                </div>

                <div className="tier-card tier-bronze">
                    <div className="card-header">
                        <h3>BRONZE</h3>
                        <span className="price-tag">Php 540 - 680</span>
                    </div>
                    <p className="tier-desc">Essential Support & Brand Awareness</p>
                    <ul className="tier-mini-list">
                        <li>3 Required Participants</li>
                        <li>Medium Logo Placement</li>
                        <li>"Also Brought To You By"</li>
                    </ul>
                </div>
            </div>

            {/* Benefits Table */}
            <section className="packages-section">
                <h2>Benefits Comparison</h2>
                <div className="packages-table-wrapper">
                    <table className="packages-table">
                        <thead>
                            <tr>
                                <th>Benefits</th>
                                <th>Gold</th>
                                <th>Silver</th>
                                <th>Bronze</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Billing Acknowledgement</td>
                                <td>"In partnership with"</td>
                                <td>"Brought to you by"</td>
                                <td>"Also brought to you by"</td>
                            </tr>
                            <tr>
                                <td>Logo Inclusion (Pubmats)</td>
                                <td>Large</td>
                                <td>Medium</td>
                                <td>Medium</td>
                            </tr>
                            <tr>
                                <td>Required OECES Member Likes</td>
                                <td>20 members</td>
                                <td>15 members</td>
                                <td>10 members</td>
                            </tr>
                            <tr>
                                <td>Live Acknowledgement</td>
                                <td>Before & After</td>
                                <td>Before & After</td>
                                <td>Before & After</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            {/* Responsibilities Table */}
            <section className="packages-section">
                <h2>Partner Responsibilities</h2>
                <div className="packages-table-wrapper">
                    <table className="packages-table">
                        <thead>
                            <tr>
                                <th>Responsibilities</th>
                                <th>Gold</th>
                                <th>Silver</th>
                                <th>Bronze</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Required Participants</td>
                                <td>8</td>
                                <td>5</td>
                                <td>3</td>
                            </tr>
                            <tr>
                                <td>Facebook Page Likes/Follows</td>
                                <td>15 unique</td>
                                <td>10 unique</td>
                                <td>5 unique</td>
                            </tr>
                            <tr>
                                <td>Pubmat Likes & Shares</td>
                                <td>15 unique</td>
                                <td>10 unique</td>
                                <td>5 unique</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            {/* Registration Timeline */}
            <section className="packages-section">
                <h2>Registration Timeline & Fees</h2>
                <ul className="resp-list">
                    <li><strong>Early Bird (On or before March 07, 2026):</strong> Php 540 for all tiers</li>
                    <li><strong>Regular (Mar 8 - Mar 22, 2026):</strong> Gold: Php 540 | Silver: Php 555 | Bronze: Php 570</li>
                    <li><strong>Late (Mar 23 - Apr 5, 2026):</strong> Php 680 for all tiers</li>
                </ul>
            </section>
        </div>
    );
};

export default Packages;